// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1YcoM","info":"Note_info__2H6XW","note":"Note_note__uJRLO","actions":"Note_actions__2Gg7Z"};